interface EvidenciaProps {
  id: string
  url: string
}

export class Evidencia {
  constructor(private readonly props: EvidenciaProps) {}

  get id() {
    return this.props.id
  }

  get url() {
    return this.props.url
  }
}
